import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS, observable} from "mobx";
import Footer from './WatchFooter';
import $ from 'jquery';
import _ from 'lodash';
import RainfallWatchMob from './RainfallWatchMob';
import {standardBasinOrder} from '../../libs/config';

@inject('markerStore', 'contentStore')
@observer
class RainfallWatch extends React.Component {

  @observable scrollTop = 0;

  componentDidMount(){
    let x = $(window);
    x.scroll(() => {
      this.scrollTop = x.scrollTop();
    })
  }

  getSortedArray = (items) => {
    items = items.filter(item => item.averages.reduce((acc, i) => i.value === null ? acc += 1 : acc += 0, 0) < 5);

    let sortedArray = [];
    let dangerItems = items.filter(item => item.status === 'DANGER').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    let warningItems = items.filter(item => item.status === 'WARNING').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    let bwlItems = [];
    // let ndItems = items.filter(item => item.status === null);

    let groupedBwlItems = _.groupBy(items.filter(item => item.status === 'BELOW WARNING LEVEL').sort((a, b) => standardBasinOrder.indexOf(a.basin) < standardBasinOrder.indexOf(b.basin) ? -1: 1), item => item.basin);
    Object.keys(groupedBwlItems).map(key => {
      let basinStationWithIndex = groupedBwlItems[key].filter(item => !!item.stationIndex).sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1),
        basinStationWithoutIndex = groupedBwlItems[key].filter(item => !item.stationIndex);
      bwlItems = [...bwlItems, ...basinStationWithIndex, ...basinStationWithoutIndex]
    });

    if(dangerItems.length) sortedArray = [ ...sortedArray, ...dangerItems.filter(b => b.stationIndex), ...dangerItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    if(warningItems.length) sortedArray = [ ...sortedArray, ...warningItems.filter(b => b.stationIndex ), ...warningItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    if(bwlItems.length) sortedArray = [ ...sortedArray, ...bwlItems];
    // if(ndItems.length) sortedArray = [ ...sortedArray, ...ndItems.sort((a,b) => a.stationIndex && a.name < b.name ?-1:1)];

    return sortedArray;
  };

  scrollToBottom = () => {
    let $app = $('html, body');
    $app.animate({scrollTop: $app.height()}, 800);
  };

  render() {
    const {markerStore, contentStore: {alerts}} = this.props;
    console.log(new Date(), toJS(markerStore.rainfall_raw));
    // console.log(this.props.mobView);
    if(this.props.mobView){
      return <RainfallWatchMob/>
    }
    return (
      <div style={{margin:'-10px'}}>
        {/*<h1 className="text-center watch"><b>RAINFALL WATCH</b></h1>*/}
        {/*{((alerts.length === 0 && this.scrollTop >= 150) || (alerts.length >= 0 && this.scrollTop >= 172)) ? <table className="watch_table" style={{position: 'fixed', top: 0, width: '100%', zIndex: 2}}>*/}
          {/*<thead className="watch_table_thead">*/}
          {/*<tr className="watch_table_tr">*/}
            {/*<th className="watch_table_th" rowSpan="2" width='3%'>S.N</th>*/}
            {/*<th className="watch_table_th" rowSpan="2" width='7%'>Basin Name</th>*/}
            {/*<th className="watch_table_th" rowSpan="2" width='5%'>Station Index</th>*/}
            {/*<th className="watch_table_th" rowSpan="2" width='15%'>Station Name</th>*/}
            {/*<th className="watch_table_th" rowSpan="2" width='5%'>District</th>*/}
            {/*<th colSpan="5" className="colspan watch_table_th" width='45%' style={{color:'white'}}>Accumulated Rainfall in mm (in Last)</th>*/}
            {/*<th className="watch_table_th" rowSpan="2" width='20%'>*/}
              {/*Status*/}
              {/*<a style={{cursor:'pointer'}} onClick={this.scrollToBottom}>***</a>*/}
              {/*/!*<a onClick={() => window.scrollTo(0,document.body.scrollHeight)}>***</a>*!/*/}
            {/*</th>*/}
          {/*</tr>*/}
          {/*<tr className="watch_table_tr">*/}
            {/*<th className="rowspan watch_table_th">1 hour</th>*/}
            {/*<th className="rowspan watch_table_th">3 hour</th>*/}
            {/*<th className="rowspan watch_table_th">6 hour</th>*/}
            {/*<th className="rowspan watch_table_th">12 hour</th>*/}
            {/*<th className="rowspan watch_table_th">24 hour</th>*/}
          {/*</tr>*/}
          {/*</thead>*/}
        {/*</table>: null}*/}
        <table className="watch_table" style={{width: '100%'}}>
          <caption className="watch_table_caption">Last updated on {markerStore.rainfall_lastUpdateTime}</caption>
          <thead className="watch_table_thead">
          <tr className="watch_table_tr">
            <th className="watch_table_th" rowSpan="2" width='3%'>S.N</th>
            <th className="watch_table_th" rowSpan="2" width='7%'>Basin Name</th>
            <th className="watch_table_th" rowSpan="2" width='5%'>Station Index</th>
            <th className="watch_table_th" rowSpan="2" width='15%'>Station Name</th>
            <th className="watch_table_th" rowSpan="2" width='5%'>District</th>
            <th colSpan="5" className="colspan watch_table_th" width='45%' style={{color:'white'}}>Accumulated Rainfall in mm (in Last)</th>
            <th className="watch_table_th" rowSpan="2" width='20%'>
              Status
              <a style={{cursor:'pointer'}} onClick={this.scrollToBottom}>***</a>
              {/*<a onClick={() => window.scrollTo(0,document.body.scrollHeight)}>***</a>*/}
            </th>
          </tr>
          <tr className="watch_table_tr">
            <th className="rowspan watch_table_th" style={{top: "41px"}}>1 hour</th>
            <th className="rowspan watch_table_th" style={{top: "41px"}}>3 hour</th>
            <th className="rowspan watch_table_th" style={{top: "41px"}}>6 hour</th>
            <th className="rowspan watch_table_th" style={{top: "41px"}}>12 hour</th>
            <th className="rowspan watch_table_th" style={{top: "41px"}}>24 hour</th>
          </tr>
          </thead>
          <tbody className="watch_table_tbody">
          {
            markerStore.rainfall_raw && this.getSortedArray(markerStore.rainfall_raw).map((item, index) =>  (
              <tr key={item.id} className={item.status ? `${item.status.split(' ')[0]} watch_table_tr` :'watch_table_tr'} id={item.name}>
                <td className="space watch_table_td" width='3%'>{index + 1}</td>
                <td className="watch_table_td" width='7%'>{item.basin}</td>
                <td className="watch_table_td" width='5%'>{item.stationIndex}</td>
                <td className="watch_table_td" width='15%'>{item.name}</td>
                <td className="watch_table_td" width='5%'>{item.district}</td>
                {item.averages.map((interval, tdi) => (
                  <td key={tdi} className="rowspan watch_table_td">{interval.value}</td>
                ))}
                <td className="watch_table_td" width='20%'>
                  <div>{item.status}</div>
                  {/*{item.status === 'DANGER' || item.status === 'WARNING' ? <Alarm/> : null}*/}
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
        <Footer/>
      </div>
    );
  }
}


export default RainfallWatch;





// WEBPACK FOOTER //
// ./src/components/Watch/RainfallWatch.js